import { ShoppingBag } from 'lucide-react';

export const MysticStoreSection = () => {
  return (
    <section id="store" className="py-24 bg-background relative">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-8 text-foreground leading-tight">
            The Slow Shop
          </h2>
          <div className="w-32 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-6"></div>
        </div>

        <div className="text-center max-w-4xl mx-auto">
          <div className="bg-card/30 backdrop-blur-sm rounded-2xl p-12 border border-border/50 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="space-y-8">
              <div className="flex justify-center mb-8">
                <div className="w-20 h-20 rounded-full border-2 border-accent/30 bg-gradient-to-br from-accent/10 to-accent/5 flex items-center justify-center shadow-lg">
                  <ShoppingBag className="w-10 h-10 text-accent" />
                </div>
              </div>
              
              <div className="text-center space-y-4">
                <p className="text-2xl font-serif text-foreground mb-4">
                  Opening Soon
                </p>
                <p className="text-xl text-muted-foreground font-light leading-relaxed">
                  A collection of meaningful clothing designed by local artists, and intentional objects that let you wear your values and carry the message.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};